import React, { useState } from 'react';
import './PopUps.scss';
import { Button, makeStyles, Collapse } from '@material-ui/core';
import StyledRadioInput from "../../../Helpers/Inputs/StyledRadioInput";
import { Form, Col, Row } from 'react-bootstrap';

const useStyles = makeStyles((theme) => ({
    primaryColor: {
        color: theme.palette.primary.main
    }
}));

export default function PopUpRadioQuestions(props) {
    const { question, options, onBack, onStartOver, id, setAnswer, value, result, colWidth, isNeedsAnalysis, step, getSelectedInsurance } = props;
    const classes = useStyles();
    const [expand, setExpand] = useState(false);
    const [showProceed, setShowProceed] = useState(true);

    return (
        <div className='help-decide p-3'>
            <a className={`hideShow-link button-hide ${classes.primaryColor}`} onClick={() => onBack()}>Go Back</a> &nbsp;&nbsp;&nbsp;
            {id !== 'health_impairment' ? <a className={`hideShow-link button-hide ${classes.primaryColor}`} onClick={onStartOver}>Start Over</a> : ""}
            {isNeedsAnalysis && step && <h5 className='mt-3'>Question {step}/8</h5>}
            {isNeedsAnalysis && !step &&
                <div className='mb-3'>
                    <h5 className={`mt-3 text-left ${classes.primaryColor}`}>Your Client's Life Insurance Analysis</h5>
                    <div className='text-right negative-margin'>
                        {
                            showProceed ?
                                <Button variant='contained' color='primary' onClick={() => setShowProceed(false)}>Proceed</Button> :
                                <React.Fragment>
                                    {result.term && <span><Button variant='contained' color='primary' onClick={() => getSelectedInsurance('Term')}>Term Life</Button></span>}
                                    {result.perm && <span className='mx-2'><Button variant='contained' color='primary' onClick={() => getSelectedInsurance('Perm')}>Permanent Life</Button></span>}
                                </React.Fragment>
                        }
                    </div>
                </div>}
            {question && <p className='help-text pt-1'>{question}
                {id === 'client_participate' &&
                    <React.Fragment>
                        <a className={`hideShow-link button-hide ${classes.primaryColor}`} onClick={() => setExpand(!expand)}>{expand ? ' View Less' : ' View Examples'}</a>
                        <Collapse in={expand}>
                            <Row className='pt-2'>
                                <Col md={4}>
                                    <div>Private aviation</div>
                                    <div>Scuba diving</div>
                                    <div>Ballooning</div>
                                    <div>Motor sports</div>
                                </Col>
                                <Col md={4}>
                                    <div>Sky diving</div>
                                    <div>Cliff diving</div>
                                    <div>Hang gliding</div>
                                    <div>Competitive horseback</div>
                                    <div>riding</div>
                                </Col>
                                <Col md={4}>
                                    <div>Mountain climbing</div>
                                    <div>Skiing (snow and water)</div>
                                    <div>Spelunking</div>
                                    <div>Para-sailing</div>
                                </Col>
                            </Row>
                        </Collapse>
                    </React.Fragment>}
            </p>}
            <Form.Group className='mb-0'>
                <StyledRadioInput
                    name={id}
                    id={id}
                    value={value}
                    options={options ? options : []}
                    onChange={(value) => setAnswer(id, value, options.find(x => x.value === value).rating)}
                    colWidth={colWidth || 3}
                    isTermHelpOptions={true}
                />
            </Form.Group>
            {id === 'final_screen' ?
                isNeedsAnalysis ?
                    <React.Fragment>
                        <h4 className={`mr-3 health-name ${classes.primaryColor}`}><b>{result.term} {result.perm && result.term ? ' / ' : null} {result.perm}</b></h4>
                        <p className='mt-2'>{result.summary}</p>
                    </React.Fragment>
                    :
                    <div className='d-flex'>
                        <h4 className={`mr-3 mt-2 health-name ${classes.primaryColor}`}><b>{result}</b></h4>
                        <span className='button-hide'><Button variant='contained' color='primary' onClick={() => setAnswer()}>Select</Button></span>
                    </div>
                :
                null
            }
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Product/TermLifeInsurance/PopUps/PopUpRadioQuestions.js